import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Organization
export const getOrganization = () => axios.get(`${API}/organizations/current`);
export const updateOrganizationPolicy = (policy) => axios.put(`${API}/organizations/policy`, policy);

// Departments
export const getDepartments = () => axios.get(`${API}/departments`);
export const createDepartment = (data) => axios.post(`${API}/departments`, data);
export const deleteDepartment = (id) => axios.delete(`${API}/departments/${id}`);

// Branches
export const getBranches = () => axios.get(`${API}/branches`);
export const createBranch = (data) => axios.post(`${API}/branches`, data);
export const updateBranch = (id, data) => axios.put(`${API}/branches/${id}`, data);
export const deleteBranch = (id) => axios.delete(`${API}/branches/${id}`);

// Users
export const getUsers = () => axios.get(`${API}/users`);
export const updateUser = (id, data) => axios.put(`${API}/users/${id}`, data);
export const deleteUser = (id) => axios.delete(`${API}/users/${id}`);

// Time Entries
export const clockIn = (data) => axios.post(`${API}/time-entries/clock-in`, data);
export const clockOut = (data) => axios.post(`${API}/time-entries/clock-out`, data);
export const getCurrentTimeEntry = () => axios.get(`${API}/time-entries/current`);
export const getTimeEntries = (params) => axios.get(`${API}/time-entries`, { params });
export const getFlaggedEntries = () => axios.get(`${API}/time-entries/flagged`);
export const resolveEntry = (id) => axios.put(`${API}/time-entries/${id}/resolve`);

// Vacations
export const getVacations = (params) => axios.get(`${API}/vacations`, { params });
export const createVacation = (data) => axios.post(`${API}/vacations`, data);
export const reviewVacation = (id, status, notes) => 
  axios.put(`${API}/vacations/${id}/review?status=${status}${notes ? `&notes=${encodeURIComponent(notes)}` : ''}`);
export const deleteVacation = (id) => axios.delete(`${API}/vacations/${id}`);

// Schedules
export const getSchedules = (params) => axios.get(`${API}/schedules`, { params });
export const createSchedule = (data) => axios.post(`${API}/schedules`, data);
export const updateSchedule = (id, data) => axios.put(`${API}/schedules/${id}`, data);
export const deleteSchedule = (id) => axios.delete(`${API}/schedules/${id}`);

// Dashboard
export const getDashboardStats = () => axios.get(`${API}/dashboard/stats`);
export const getForecasting = (weeks) => axios.get(`${API}/dashboard/forecasting`, { params: { weeks } });
export const getWeeklyHours = () => axios.get(`${API}/dashboard/weekly-hours`);

// Shift Swaps
export const getShiftSwaps = (params) => axios.get(`${API}/shift-swaps`, { params });
export const createShiftSwap = (data) => axios.post(`${API}/shift-swaps`, data);
export const acceptShiftSwap = (id) => axios.put(`${API}/shift-swaps/${id}/accept`);
export const rejectShiftSwap = (id, notes) => axios.put(`${API}/shift-swaps/${id}/reject${notes ? `?notes=${encodeURIComponent(notes)}` : ''}`);
export const cancelShiftSwap = (id) => axios.delete(`${API}/shift-swaps/${id}`);

// Availability
export const getAvailability = (params) => axios.get(`${API}/availability`, { params });
export const getCurrentAvailability = () => axios.get(`${API}/availability/current`);
export const setAvailability = (data) => axios.post(`${API}/availability`, data);
export const deleteAvailability = (id) => axios.delete(`${API}/availability/${id}`);
export const getTeamAvailability = (date) => axios.get(`${API}/availability/team`, { params: { date } });

// Subscription
export const getCurrentSubscription = () => axios.get(`${API}/subscription/current`);
export const getSubscriptionPlans = () => axios.get(`${API}/subscription/plans`);
export const getSupportedCurrencies = () => axios.get(`${API}/subscription/currencies`);
export const createCheckoutSession = (tier, originUrl, currency = 'usd') => 
  axios.post(`${API}/subscription/checkout?tier=${tier}&origin_url=${encodeURIComponent(originUrl)}&currency=${currency}`);
export const getCheckoutStatus = (sessionId) => axios.get(`${API}/subscription/checkout/status/${sessionId}`);
export const getPaymentTransactions = () => axios.get(`${API}/subscription/transactions`);

// Super Admin
export const getAllOrganizations = () => axios.get(`${API}/super-admin/organizations`);
export const getOrganizationDetails = (orgId) => axios.get(`${API}/super-admin/organizations/${orgId}`);
export const updateOrganizationAdmin = (orgId, data) => axios.put(`${API}/super-admin/organizations/${orgId}`, data);
export const deleteOrganizationAdmin = (orgId) => axios.delete(`${API}/super-admin/organizations/${orgId}`);
export const getAllUsers = () => axios.get(`${API}/super-admin/users`);
export const resetUserPassword = (userId, newPassword) => 
  axios.post(`${API}/super-admin/users/${userId}/reset-password`, { user_id: userId, new_password: newPassword });
export const toggleUserActivation = (userId, isActive) => 
  axios.put(`${API}/super-admin/users/${userId}/activate?is_active=${isActive}`);
export const getPlatformAnalytics = () => axios.get(`${API}/super-admin/analytics`);
export const getTierConfigurations = () => axios.get(`${API}/super-admin/tiers`);
export const updateTierConfiguration = (tier, config) => axios.put(`${API}/super-admin/tiers/${tier}`, config);

// Super Admin SMTP Configuration
export const getSMTPConfig = () => axios.get(`${API}/super-admin/smtp-config`);
export const createSMTPConfig = (config) => axios.post(`${API}/super-admin/smtp-config`, config);
export const updateSMTPConfig = (config) => axios.put(`${API}/super-admin/smtp-config`, config);
export const deleteSMTPConfig = () => axios.delete(`${API}/super-admin/smtp-config`);
export const testSMTPConfig = (toEmail) => axios.post(`${API}/super-admin/smtp-config/test`, { to_email: toEmail });

// Organization Email Settings
export const getEmailSettings = () => axios.get(`${API}/email-settings`);
export const updateEmailSettings = (settings) => axios.put(`${API}/email-settings`, settings);

// Notifications
export const getNotifications = (unreadOnly = false) => axios.get(`${API}/notifications`, { params: { unread_only: unreadOnly } });
export const getUnreadCount = () => axios.get(`${API}/notifications/unread-count`);
export const markNotificationRead = (id) => axios.put(`${API}/notifications/${id}/read`);
export const markAllNotificationsRead = () => axios.put(`${API}/notifications/read-all`);
export const deleteNotification = (id) => axios.delete(`${API}/notifications/${id}`);
export const getNotificationPreferences = () => axios.get(`${API}/notifications/preferences`);
export const updateNotificationPreferences = (prefs) => axios.put(`${API}/notifications/preferences`, prefs);

// Exports
export const exportTimeEntries = (params) => axios.get(`${API}/export/time-entries`, { params, responseType: 'blob' });
export const exportEmployees = (params) => axios.get(`${API}/export/employees`, { params, responseType: 'blob' });
export const exportSchedules = (params) => axios.get(`${API}/export/schedules`, { params, responseType: 'blob' });
export const exportVacations = (params) => axios.get(`${API}/export/vacations`, { params, responseType: 'blob' });
export const exportAnalyticsReport = (params) => axios.get(`${API}/export/analytics-report`, { params, responseType: 'blob' });
